<div class="container pt-4">
	<!-- filters -->
	<div class="row g-3 mb-3">
		<!-- search text -->
		<div class="col-sm-6">
			<input class="form-control form-control-search" type="search" autocomplete="noautocomplete"
				placeholder="Search by anything..." aria-label="text search filter" [ngModel]="filters.searchText"
				(ngModelChange)="searchChange.next($event)">
		</div>
		<!-- league -->
		<div class="col-sm-6">
			<ng-select labelForId="leagueSelect" name="leagueSelect" [items]="leaguesLookup" bindLabel="name"
				bindValue="id" [(ngModel)]="filters.leagueID" [loading]="leaguesLookupLoading"
				notFoundText="No matching leagues" [clearable]="filters.leagueID != emptyId()"
				(clear)="filters.leagueID = emptyId()" (change)="onLeagueChange()"
				[readonly]="leaguesLookupLoading || approvalsLoading()">
				<!-- selected item template -->
				<ng-template ng-label-tmp let-item="item">
					<div class="hstack gap-2" [class.fw-bold]="item.id">
						@if (item.id) { <app-league-icon /> }
						{{ item.name }}
					</div>
				</ng-template>
				<!-- dropdown item template -->
				<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
					<div class="hstack gap-2">
						@if (item.id) { <app-league-icon class="ms-2" /> }
						{{ item.name }}
					</div>
				</ng-template>
				<!-- loading template -->
				<ng-template ng-loadingspinner-tmp>
					<app-spinner />
				</ng-template>
			</ng-select>
		</div>
		<!-- team -->
		<div class="col-sm-4">
			<ng-select labelForId="teamSelect" name="teamSelect" [items]="teams" bindLabel="teamName" bindValue="teamId"
				[(ngModel)]="filters.teamID" [loading]="teamsLoading()" notFoundText="No matching teams"
				[clearable]="false" (change)="onTeamChange()" [disabled]="isTeamsDisabled()">
				<!-- selected item template -->
				<ng-template ng-label-tmp let-item="item">
					<div class="hstack gap-2" [class.fw-bold]="item.teamId">
						@if (item.teamId) { <app-team-icon /> }
						{{ item.teamName }}
					</div>
				</ng-template>
				<!-- dropdown item template -->
				<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
					<div class="hstack gap-2">
						@if (item.teamId) { <app-team-icon class="ms-2" /> }
						{{ item.teamName }}
					</div>
				</ng-template>
				<!-- loading template -->
				<ng-template ng-loadingspinner-tmp>
					<app-spinner />
				</ng-template>
			</ng-select>
		</div>
		<!-- players/coaches -->
		<div class="col-sm-6">
			<ng-select labelForId="userSelect" name="userSelect" [items]="users" [(ngModel)]="selectedUser"
				[loading]="usersLoading" notFoundText="No matching players or coaches"
				[clearable]="selectedUser != allPlayersAndCoaches()" (clear)="onUserSelect(allPlayersAndCoaches())"
				(change)="onUserSelect($event)" [disabled]="usersLoading || approvalsLoading() || !filters.teamID">
				<!-- selected item template -->
				<ng-template ng-label-tmp let-item="item">
					<div class="hstack gap-2" [class.fw-bold]="item.playerId || item.coachId">
						@if (item.playerId) { <app-player-icon /> }
						@if (item.coachId) { <app-coach-icon /> }
						{{ item.label }}
					</div>
				</ng-template>
				<!-- dropdown item template -->
				<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
					<div class="hstack gap-2">
						@if (item.playerId) { <app-player-icon class="ms-2" /> }
						@if (item.coachId) { <app-coach-icon class="ms-2" /> }
						{{ item.label }}
					</div>
				</ng-template>
				<!-- loading template -->
				<ng-template ng-loadingspinner-tmp>
					<app-spinner />
				</ng-template>
			</ng-select>
		</div>
	</div>
	<div class="row g-3 mb-4">
		<!-- document statuses -->
		<div class="col-auto document-statuses">
			<ng-select [items]="documentStatusesLookup$ | async" [multiple]="true" bindValue="id" bindLabel="name"
				[closeOnSelect]="false" [clearable]="false" [loading]="documentStatusesLookupLoading"
				[searchable]="false" [ngModel]="filters.documentStatusIDs">
				<ng-template ng-multi-label-tmp>
					<span>{{ documentStatusesLabel() }}</span>
				</ng-template>

				<ng-template ng-option-tmp let-item="item">
					<div class="w-100">
						<label class="form-check-label w-100 fw-semibold">
							<input type="checkbox" class="form-check-input me-2"
								[checked]="filters.documentStatusIDs?.includes(item.id)"
								(change)="onDocumentStatusesChange(item.id)" />
							{{ item.name }}
						</label>
					</div>
				</ng-template>
			</ng-select>
		</div>
		<!-- submission dates -->
		<div class="col-auto">
			<app-date-range-dropdown [dateRange]="{start: filters.submissionDateFrom, end: filters.submissionDateTo }"
				(dateRangeChange)="dateRangeChange($event)" />
		</div>
		<!-- submitted by -->
		<div class="col-sm-5">
			<ng-select labelForId="submitterSelect" name="submitterSelect" [items]="submitterUsers" bindLabel="name"
				bindValue="id" [clearable]="filters.submittedByUserID != emptyId()"
				(clear)="filters.submittedByUserID = emptyId()" [(ngModel)]="filters.submittedByUserID"
				[loading]="submitterUsersLoading" notFoundText="No matching users" (change)="onLoadApprovals(true)"
				[readonly]="submitterUsersLoading || approvalsLoading()">
				<!-- selected item template -->
				<ng-template ng-label-tmp let-item="item">
					<div class="hstack gap-2" [class.fw-bold]="item.id">
						{{ item.name }}
					</div>
				</ng-template>
				<!-- dropdown item template -->
				<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
					<div class="hstack gap-2">
						{{ item.name }}
					</div>
				</ng-template>
				<!-- loading template -->
				<ng-template ng-loadingspinner-tmp>
					<app-spinner />
				</ng-template>
			</ng-select>
		</div>
		<!-- document types -->
		<div class="col-8">
			<ng-select [items]="documentTypesLookup$ | async" [multiple]="true" [closeOnSelect]="false"
				[clearable]="false" [loading]="documentTypesLookupLoading" [searchable]="false"
				[(ngModel)]="filters.documentTypeIDs">
				<!-- Display selected label -->
				<ng-template ng-multi-label-tmp><span>{{ documentTypesLabel() }}</span></ng-template>

				<!-- Render each group manually -->
				<ng-template ng-option-tmp let-group="item">
					<div class="w-100">
						<!-- Group label with checkbox -->
						<label class="form-check-label w-100 fw-semibold">
							<input type="checkbox" class="form-check-input me-2" [checked]="group.selected"
								(click)="onToggleGroup(group)" />
							{{ group.groupLabel }}
						</label>

						<!-- Inner items -->
						@for (doc of group.documents; track doc.id) {
						<div class="ps-4 py-1">
							<label class="form-check-label w-100">
								<input type="checkbox" class="form-check-input me-2" [checked]="doc.selected"
									(click)="onToggleItem(doc.id)" />
								{{ doc.name }}
							</label>
						</div>
						}
					</div>
				</ng-template>
			</ng-select>
		</div>
	</div>
	<!-- sort -->
	<hr />
	<div class="d-flex justify-content-between mb-3">
		<h2 class="mb-0">
			Document Approvals
			@if (approvalsTotal !== null) {
			<span class="text-secondary">({{ approvalsTotal | number }})</span>
			}
		</h2>
		<div class="col-auto d-flex align-items-center gap-2">
			<label class="form-label mb-0 d-none d-sm-block" for="sortByDropdown">Sort by</label>
			<div class="nav-item dropdown" routerLinkActive="active" ngbDropdown>
				<a id="sortByDropdown" class="nav-link dropdown-toggle text-decoration-dotted" href="#" role="button"
					data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
					<span class="d-none d-sm-inline">
						@switch (filters.sortField) {
						@case (DocumentApprovalsSortCodes.LeagueName) { League }
						@case (DocumentApprovalsSortCodes.DateSubmitted) { Date Submitted }
						@case (DocumentApprovalsSortCodes.DocumentType) { Document Type }
						@case (DocumentApprovalsSortCodes.DocumentStatus) { Document Status }
						@case (DocumentApprovalsSortCodes.SubmittedBy) { Submitted by }
						@default { ????? }
						}
					</span>
				</a>
				<div class="dropdown-menu" aria-labelledby="sortByDropdown" ngbDropdownMenu>
					@for (sortCode of sortFields; track sortCode) {
					<button class="dropdown-item" ngbDropdownItem (click)="onSortChange(sortCode)">{{
						DocumentApprovalsSortCodesLabels[sortCode] }}</button>
					}
				</div>
			</div>
		</div>
	</div>
	<!-- listing -->
	@if (approvalsLoading() && currentPage === 1) {
	<div class="border border-secondary-subtle">
		<app-table-placeholder [columnsCount]="6" [rowsCount]="4" />
	</div>
	} @else if (approvalsError() && currentPage === 1) {
	<app-error message="Error loading document approvals" (retry)="onLoadApprovals(true)" />
	} @else if (!approvals.length) {
	<div class="card">
		<div class="card-body"><app-empty message="No document approvals matching your search criteria" />
		</div>
	</div>
	} @else {
	<div infiniteScroll (scrolled)="onLoadApprovals(false)">
		<div class="table-responsive">
			<table class="table table-hover table-bordered align-middle mb-0">
				<thead class="table-secondary">
					<tr>
						<th scope="col">League/Team/Player/Coach</th>
						<th class="text-center" scope="col">Submitted On</th>
						<th scope="col">Submitted by</th>
						<th scope="col">Document Type</th>
						<th scope="col">Status</th>
						<th class="text-center" scope="col">ACTIONS</th>
					</tr>
				</thead>
				<tbody>
					@for (approval of approvals; track approval.documentSubmissionID) {
					<tr>
						<td>
							<div class="d-flex align-items-center gap-1 flex-wrap">
								@switch (approval.documentSubjectId) {
								@case (DocumentSubjectCodes.LeagueDocument) {
								<!-- stretched-link -->
								<h5 class="mb-0">
									<app-league-icon class="me-2" />
									<a class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId]">{{ approval.leagueName }}</a>
								</h5>
								} @case (DocumentSubjectCodes.TeamDocument) {
								<h5 class="mb-0"><app-team-icon class="me-1" /> <a
										class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId, 'teams', approval.teamId]"
										[queryParams]="{ leagueName: approval.leagueName }">{{
										approval.teamName }}</a></h5>
								<h6 class="mb-0 fw-normal text-secondary"> - <a class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId]">{{ approval.leagueName }}</a>
								</h6>
								} @case (DocumentSubjectCodes.PlayerDocument) {
								<h5 class="mb-0"><app-player-icon class="me-1" /> {{ approval.playerName }}</h5>
								<h6 class="mb-0 fw-normal text-secondary"> - <a class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId, 'teams', approval.teamId]"
										[queryParams]="{ leagueName: approval.leagueName }">{{
										approval.teamName }}</a></h6>
								<h6 class="mb-0 fw-normal text-secondary"> - <a class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId]">{{ approval.leagueName }}</a>
								</h6>
								} @case (DocumentSubjectCodes.CoachDocument) {
								<h5 class="mb-0"><app-coach-icon class="me-1" /> {{ approval.coachName }}</h5>
								<h6 class="mb-0 fw-normal text-secondary"> - <a class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId, 'teams', approval.teamId]"
										[queryParams]="{ leagueName: approval.leagueName }">{{
										approval.teamName }}</a></h6>
								<h6 class="mb-0 fw-normal text-secondary"> - <a class="text-reset text-decoration-none"
										[routerLink]="['/leagues/', approval.leagueId]">{{ approval.leagueName }}</a>
								</h6>
								} @default {
								<h5 class="mb-0">???</h5>
								}
								}
							</div>
						</td>
						<td class="text-center">
							{{ approval.uploadedDateTime| date:'M/dd/yyyy' }}
						</td>
						<td>
							{{ approval.uploaderName }}
						</td>
						<td>
							{{ approval.documentName }}
						</td>
						<td>
							<app-status-icon class="small"
								[statusType]="DocumentSubjectStatusTypeMapping[approval.documentSubjectId]"
								[statusCode]="approval.statusId" [statusName]="approval.statusName"
								[showStatusName]="true" />
						</td>
						<td class="text-center">
							@if (approval.documentSubjectId !== DocumentSubjectCodes.LeagueDocument) {
							<app-document-actions [leagueID]="approval.leagueId" [leagueName]="approval.leagueName"
								[teamID]="approval.teamId" [teamName]="approval.teamName" [coachID]="approval.coachId"
								[coachName]="approval.coachName" [teamPlayerID]="approval.playerTeamId"
								[teamPlayerName]="approval.playerName" [viewFileID]="approval.uploadedFileId"
								[viewSubmissionID]="approval.documentSubmissionID"
								[viewFileType]="approval.uploadedFileType" [viewFileName]="approval.documentName"
								[showIntake]="false" [showUpload]="false" buttonSizeClass="btn-sm"
								(approved)="onApprovedOrRejected($event)" (rejected)="onApprovedOrRejected($event)" />
							} @else {
							@if (approval.documentId === LeagueDocumentTypeCodes.AffiliationApplication) {
							<a class="btn btn-sm btn-outline-dark"
								[routerLink]="['/leagues/', approval.leagueId, 'apps', 'affiliation', approval.documentSubmissionID, 'view']"
								ngbTooltip="View Affiliation Application"><app-view-icon /></a>
							} @else if (approval.documentId === LeagueDocumentTypeCodes.TournamentApplication) {
							<a class="btn btn-sm btn-outline-dark"
								[routerLink]="['/leagues/', approval.leagueId, 'apps', 'tournament', approval.documentSubmissionID, 'view']"
								ngbTooltip="View Tournament Application"><app-view-icon /></a>
							}
							}
						</td>
					</tr>
					}
				</tbody>
				@if ((approvalsLoading() || approvalsError()) && currentPage > 1) {
				<tfoot>
					<tr>
						<td colspan="6">
							@if (approvalsLoading()) {
							<app-table-placeholder [columnsCount]="6" [rowsCount]="4" />
							}
							@if (approvalsError()) {
							<app-error message="Error loading more approvals" (retry)="onLoadApprovals(true)" />
							}
						</td>
					</tr>
				</tfoot>
				}
			</table>
		</div>
	</div>
	}

	<div class="my-5"></div>
</div>
